import { FC, ReactElement } from "react"
import { useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"

type PermsWrapperProps = {
  children: ReactElement
  perm: string
  isProtected?: boolean
}

const PermsWrapper = (props: PermsWrapperProps) => {
  const { children, perm, isProtected } = props

  const navigate = useNavigate()

  const allPerms = useSelector((state: any) => {
    return state.rolesAndPerms.userPerms
  })

  if (perm == "bypass") {
    return <>{children}</>
  } else if (allPerms?.includes(perm)) {
    return <>{children}</>
  } else if (isProtected) {
    navigate("/")
  }

  return null
}

export default PermsWrapper
